module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Light-01a5a67f99c4c73d3fca39500fcb6702.woff2";